import { createAuthClient } from 'better-auth/react';

const API_URL =
  import.meta.env.VITE_API_URL ||
  (import.meta.env.DEV
    ? 'http://localhost:3000'
    : typeof window !== 'undefined'
      ? window.location.origin
      : 'http://localhost:3000');

export const authClient = createAuthClient({
  baseURL: `${API_URL}/api/auth`,
  disableDefaultFetchPlugins: true,
  fetchOptions: {
    credentials: 'include',
  },
});
